const h = window.location.hostname
export const playgroundUrl =
    h === 'endiagram.com' ? 'https://playground.endiagram.com'
    : h === 'staging.endiagram.com' ? 'https://staging-playground.endiagram.com'
    : 'https://playground.endiagram.com'
